/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Gc_Search_Guides_What_Is_Gridcraft_Sections_4_Steps_1Inputs */

const en_gc_search_guides_what_is_gridcraft_sections_4_steps_1 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_4_Steps_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Find one input and one result that depends on it. Write down what should happen when you change the input.`)
};

const zh_gc_search_guides_what_is_gridcraft_sections_4_steps_1 = /** @type {(inputs: Gc_Search_Guides_What_Is_Gridcraft_Sections_4_Steps_1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`找到一个输入值和一个依赖它的结果，写下修改输入后应该发生的变化。`)
};

/**
* | output |
* | --- |
* | "Find one input and one result that depends on it. Write down what should happen when you change the input." |
*
* @param {Gc_Search_Guides_What_Is_Gridcraft_Sections_4_Steps_1Inputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const gc_search_guides_what_is_gridcraft_sections_4_steps_1 = /** @type {((inputs?: Gc_Search_Guides_What_Is_Gridcraft_Sections_4_Steps_1Inputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Gc_Search_Guides_What_Is_Gridcraft_Sections_4_Steps_1Inputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_gc_search_guides_what_is_gridcraft_sections_4_steps_1(inputs)
	return zh_gc_search_guides_what_is_gridcraft_sections_4_steps_1(inputs)
});
export { gc_search_guides_what_is_gridcraft_sections_4_steps_1 as "gc.search_guides.what_is_gridcraft.sections.4.steps.1" }